import { createContext } from 'react';

interface Context {
  tab?: string;
  setTab?: (tab: string) => void;
}

export const ActivityItemContext = createContext<Context>({
  tab: undefined,
  setTab: () => {},
});
